import React from "react";

import classNames from "classnames";

import styles from "./style.module.scss";
import ContactSupportLink from "ui/ContactSupportLink";
import { SpinnerIcon } from "ui/Icons";
import { useLoadingContext } from "providers/WithLoadingContext";

function Loading({
  error,
  small,
  className,
}: {
  error?: boolean;
  small?: boolean;
  className?: string;
}) {
  const context = useLoadingContext();
  const errDetail = context?.error;
  return (
    <div
      className={classNames(
        styles.container,
        !small && styles.containerBig,
        className,
      )}
    >
      {error ? (
        <>
          <div className={styles.loading}>Loading...</div>
          <div className={styles.error}>
            {errDetail?.message ?? (
              <>
                Internal Error: Please{" "}
                <ContactSupportLink>contact support</ContactSupportLink>
              </>
            )}
          </div>
        </>
      ) : (
        <SpinnerIcon className="text-[20px]" />
      )}
    </div>
  );
}

export default Loading;
